module.exports = __webpack_public_path__ + "static/img/login_logo.8664bfc0.png";